// A tiny module-level registry for "where in the app is the tester right now",
// read by collectClientContext() when a feedback report is filed.
//
// The feedback modal lives in the global Topbar and knows nothing about the
// page under it — the URL carries the novel *id*, but not the current scene,
// the scene's title, or which editor tab is open. Rather than prop-drill that
// state through the Topbar, the player/editor pages publish it here in an effect
// and clear it on unmount. Last writer wins; there is only ever one such page
// mounted at a time.

export interface FeedbackPageContext {
  /** Title of the novel currently open. */
  novelTitle?: string;
  /** Id of the scene the tester is on (player) or has selected (editor). */
  sceneId?: string;
  /** Human title of that scene. */
  sceneTitle?: string;
  /** Active editor tab (graph / cast / locations / settings / warnings). */
  editorTab?: string;
}

let current: FeedbackPageContext = {};

/** Publish the current page's feedback context (replaces the previous value). */
export function setFeedbackPageContext(context: FeedbackPageContext): void {
  current = context;
}

/** Clear it — call on unmount so a stale scene doesn't leak into a later report. */
export function clearFeedbackPageContext(): void {
  current = {};
}

/** Snapshot the current page context for a feedback report. */
export function getFeedbackPageContext(): FeedbackPageContext {
  return current;
}
